import React from 'react';

// Sorts object keys at every nesting level so key-insertion order doesn't affect equality
const stableStringify = (value: object) =>
    JSON.stringify(value, (_, v: unknown) =>
        v !== null && typeof v === 'object' && !Array.isArray(v) ? Object.fromEntries(Object.entries(v as Record<string, unknown>).sort()) : v
    );

const useIsFormDirty = (formData: object, resetKey?: unknown): boolean => {
    const origHashRef = React.useRef(stableStringify(formData));
    const [isDirty, setIsDirty] = React.useState(false);

    React.useEffect(() => {
        origHashRef.current = stableStringify(formData);
        setIsDirty(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetKey]);

    React.useEffect(() => {
        setIsDirty(stableStringify(formData) !== origHashRef.current);
    }, [formData]);

    return isDirty;
};

export default useIsFormDirty;
